/**
 * Netlify functions base path
 */
const FUNCTIONS_PATH = "/.netlify/functions";

/**
 * Netlify function Query parameter for term types - RESOURCE_TERM_CONTENT_TYPE_ID | NEWS_TERM_CONTENT_TYPE_ID
 */
const TERM_TYPE_PARAM = "termContentType";

export { FUNCTIONS_PATH, TERM_TYPE_PARAM };
